import { DateTimeQuestion } from "./datetime-question";
import type { QuestionTypeRendererProps } from "./shared";

type DateTimeQuestionProps = QuestionTypeRendererProps<"datetime">;

export default function DateTimeQuestionType(props: DateTimeQuestionProps) {
  return <DateTimeQuestion {...props} kind="datetime" />;
}
